export enum HomeType  {
    Hohh = 'hohh',
    MyRumah = 'myrumah'
}

export enum HomeTypeName {
    HOHH = 'HOHH',
    MyRumah = 'MyRumah'
}